import useTranslate from 'modules/local/useTranslate'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify} from 'views/AppLocals/factory/createNotification'
import {moderation_approveItem_Api, moderation_rejectItem_Api} from '../../../../apis/moderation'

const useApproval = ({
    notifyListeners: {
        onApproved = () => {},
        onRejected = () => {},
    } = {},
} = {}) => {
    const t = useTranslate()
    const onError = notifyOnError(t)

    const {handleAsyncAction: onApprove, isLoading: isApproving} = useAsyncAction({
        onError,
        apiInfo: moderation_approveItem_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onApproved(result, data)
        },
    })

    const {handleAsyncAction: onReject, isLoading: isRejecting} = useAsyncAction({
        onError,
        apiInfo: moderation_rejectItem_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRejected(result, data)
        },
    })

    return {
        onApprove,
        onReject,
        isApproving,
        isRejecting,
    }
}

export default useApproval
